import script from "./EditRule.vue?vue&type=script&setup=true&lang=js"
export * from "./EditRule.vue?vue&type=script&setup=true&lang=js"

import "./EditRule.vue?vue&type=style&index=0&id=43b80ce8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43b80ce8"]])

export default __exports__